import { FormPartialDataUsPersonInfo } from ".";

export const emptyValuesUsPersonInfo: FormPartialDataUsPersonInfo = {
  ssn: "",
  firstName: "",
  middleName: "",
  lastName: "",
  usPersonSince: "always",
  usPersonDate: undefined
};
